import React from "react";
import { Instagram, MessageCircle, Youtube, Twitch } from "lucide-react";

const SOCIAL = [
    { icon: MessageCircle, label: "Discord", href: "https://discord.gg/placeholder" },
    { icon: Instagram, label: "Instagram", href: "#" },
    { icon: Youtube, label: "YouTube", href: "#" },
    { icon: Twitch, label: "Twitch", href: "#" },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-black pt-20 pb-10 overflow-hidden border-t border-white/10"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-12 mb-16">
                    <div className="lg:col-span-5">
                        <div className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow mb-3">
                            ▸ Forza Pilots // FiveM
                        </div>
                        <p className="text-white/60 text-base max-w-md leading-relaxed">
                            Servidor de fugas, perseguições e RP de adrenalina.
                            Nascido em 2024, feito por quem ama o asfalto.
                        </p>
                    </div>

                    <div className="lg:col-span-4">
                        <h4 className="font-heading text-2xl uppercase mb-4 text-white">
                            Navega
                        </h4>
                        <ul className="grid grid-cols-2 gap-2 font-mono text-xs uppercase tracking-[0.2em] text-white/60">
                            {[
                                { id: "sobre", l: "Sobre" },
                                { id: "features", l: "Recursos" },
                                { id: "regras", l: "Regras" },
                                { id: "staff", l: "Staff" },
                                { id: "conectar", l: "Conectar" },
                                { id: "galeria", l: "Galeria" },
                                { id: "faq", l: "FAQ" },
                            ].map((n) => (
                                <li key={n.id}>
                                    <a
                                        href={`#${n.id}`}
                                        data-testid={`footer-link-${n.id}`}
                                        className="hover:text-neon-yellow transition-colors"
                                    >
                                        / {n.l}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <h4 className="font-heading text-2xl uppercase mb-4 text-white">
                            Cola junto
                        </h4>
                        <div className="flex flex-wrap gap-3">
                            {SOCIAL.map((s, i) => {
                                const Icon = s.icon;
                                return (
                                    <a
                                        key={i}
                                        href={s.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={s.label}
                                        data-testid={`social-${s.label.toLowerCase()}`}
                                        className="w-12 h-12 border border-white/20 flex items-center justify-center hover:bg-neon-yellow hover:text-black hover:border-neon-yellow transition-colors"
                                    >
                                        <Icon size={18} />
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* Big text */}
                <div
                    className="font-heading uppercase leading-[0.8] text-stroke-yellow text-center select-none"
                    style={{ fontSize: "clamp(3rem, 18vw, 16rem)" }}
                >
                    FORZA PILOTS
                </div>

                <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
                    <span>© 2024 Forza Pilots · Todos os direitos burlados</span>
                    <span>// Não afiliado a Rockstar ou Cfx.re</span>
                </div>
            </div>
        </footer>
    );
}
